import { useEffect, useState } from 'react';

const STORAGE_KEY = 'cloakling.announcement.dismissed.v1';

export type AnnouncementBarProps = {
  message: string;
  href?: string;
};

export function AnnouncementBar({ message, href }: AnnouncementBarProps) {
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      setDismissed(stored === 'true');
    } catch {
      setDismissed(false);
    }
  }, []);

  function handleDismiss() {
    setDismissed(true);
    try {
      window.localStorage.setItem(STORAGE_KEY, 'true');
    } catch {
      // localStorage unavailable — graceful no-op
    }
  }

  if (dismissed) {
    return null;
  }

  const Inner = (
    <span className="inline-flex items-center gap-2.5">
      <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-cloak-accent" />
      <span className="text-[13px] font-medium text-page">{message}</span>
      <span aria-hidden="true" className="text-page">→</span>
    </span>
  );

  return (
    <div
      role="region"
      aria-label="Site announcement"
      className="relative flex h-11 items-center justify-center bg-ink px-8"
    >
      {href ? (
        <a href={href} className="no-underline">
          {Inner}
        </a>
      ) : (
        Inner
      )}
      <button
        type="button"
        onClick={handleDismiss}
        aria-label="Dismiss announcement"
        className="absolute right-3 inline-flex h-7 w-7 items-center justify-center rounded text-page/60 transition-colors hover:bg-page/5 hover:text-page"
      >
        <span aria-hidden="true" className="text-base leading-none">×</span>
      </button>
    </div>
  );
}
